<template>
  <div>
    <router-view/>
    <AlertComponents v-if="showAlert" />
    <BaseAlert />
    <Transition name="slide">
      <FloatNotificationWrapper v-if="notification && notification.length" @clearnotification="clearNotification()" :multi="notification.length > 1" @onExpand="(e) => onExpand(e)">
        <FloatNotification @close-notification="closeNotification" v-for="(notif, index) in filteredNotif" :key="index" :notification="notif" :isExpand="isExpandedNotif" />
      </FloatNotificationWrapper>
    </Transition>
    <audio id="sound"></audio>
  </div>
  <div>
    <h5 class="mobile-token" @click="copyText" v-if="$route.query.mobileNotif"> <input type="text" id="copy" disabled v-model="token" /> </h5>
  </div>
</template>
<script>
import AlertComponents from './components/AlertComponent.vue'
import BaseAlert from './components/BaseAlert.vue'
import FloatNotification from './components/FloatNotification.vue'
import FloatNotificationWrapper from './components/FloatNotificationWrapper.vue'
import FBase from 'firebase/app'
import 'firebase/messaging'
import axios from 'axios'

export default {
  components: {
    AlertComponents,
    FloatNotification,
    FloatNotificationWrapper,
    BaseAlert
  },
  data () {
    return {
      notification: [],
      token: '',
      isExpandedNotif: false
    }
  },
  async mounted () {
    if (FBase.messaging.isSupported()) {
      await this.getTokenFCM()
      this.receiveMessage()
    }
  },
  computed: {
    showAlert () {
      return this.$store.getters.getAlertState
    },
    filteredNotif () {
      if (this.isExpandedNotif) {
        return this.notification.slice(0, 10)
      } else {
        return this.notification.slice(0, 1)
      }
    }
  },
  methods: {
    async getTokenFCM () {
      try {
        this.$messaging.requestPermission()
          .then(() => {
            // eslint-disable-next-line no-unused-expressions
            this.$messaging.getToken()
              .then((token) => {
                this.token = token
                this.registerToken(token)
              })
          })
          .catch((err) => {
            this.logger('Unable to get token! Please allow permission for notification! ', err)
          })
      } catch (e) {
        this.logger(e)
      }
    },
    receiveMessage () {
      this.$messaging.onMessage((payload) => {
        this.logger({ payload })
        this.notification.unshift(payload)
      })
    },
    closeNotification (data) {
      this.notification = this.notification.filter(item => {
        return item.fcmMessageId !== data
      })
    },
    async registerToken (token) {
      const params = {
        registration_token: token
      }
      await axios.post('notification/client/registertoken', params)
    },
    copyText () {
      /* Get the text field */
      const copyText = document.getElementById('copy')

      /* Select the text field */
      copyText.select()
      copyText.setSelectionRange(0, 99999) /* For mobile devices */

      /* Copy the text inside the text field */
      navigator.clipboard.writeText(copyText.value)

      /* Alert the copied text */
      alert('Copied the text: ' + copyText.value)
    },
    onExpand (isExpanded) {
      this.isExpandedNotif = isExpanded
    },
    clearNotification () {
      this.isExpandedNotif = false
      this.notification = []
    }
  }
}
</script>
<style scoped lang="scss">
.mobile-token {
  position: fixed;
  bottom: 1em;
  background-color: aquamarine;
  padding: .2em;
}

.slide-enter-active {
  transition: all 0.3s ease-out;
}

.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

</style>
